import { render } from "./ModalExample.vue?vue&type=template&id=31d29b5a"
import script from "./ModalExample.vue?vue&type=script&lang=js"
export * from "./ModalExample.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src782236838/src/mess-barcode-scan-req-serv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__